// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@4.3.0_webpack@5.104.1_webpack-cli@6.0.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".create-edit-object {\n  padding-right: 24px;\n}\n.create-edit-object .ant-popover-disabled-compatible-wrapper {\n  width: 100%;\n}\n.create-edit-object .file-error {\n  border-color: #ff4d4f;\n  border-width: 1px;\n  border-style: solid;\n}\n.create-edit-object .proxy-selector {\n  margin-bottom: 24px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
